module.exports = __webpack_public_path__ + "ef555bf639a11bd65ae3065263788bba.png";